import { render, staticRenderFns } from "./TariffHomeItem.vue?vue&type=template&id=047bdd4d&scoped=true&"
import script from "./TariffHomeItem.vue?vue&type=script&lang=ts&"
export * from "./TariffHomeItem.vue?vue&type=script&lang=ts&"
import style0 from "./TariffHomeItem.vue?vue&type=style&index=0&id=047bdd4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047bdd4d",
  null
  
)

export default component.exports